const passwordRegexAllValid = /^[!-~]+$/
const passwordRegexContainsAlphabet = /[a-zA-z]/
const passwordRegexContainsDigit = /\d/
const passwordRegexContainsSymbol = /[!-/:-@[-`{-~]/

export const msgTooShort = '8文字以上を入力してください'
export const msgTooLong = '72文字以下にしてください'
export const msgHas2OfDigitSymbolAlphabet =
  '記号か数字を含む英字を入力してください'
export const msgContainsJapanese = '英数字・記号だけで入力してください'

type Validator = {
  errorMessage: string
  validate(value: string): boolean
}

export const passwordValidators: readonly Validator[] = [
  {
    errorMessage: msgTooShort,
    validate(value: string): boolean {
      return value.length >= 8
    },
  },
  {
    errorMessage: msgTooLong,
    validate(value: string): boolean {
      return value.length <= 72
    },
  },
  {
    errorMessage: msgHas2OfDigitSymbolAlphabet,
    validate(value: string): boolean {
      const hasDigit = passwordRegexContainsDigit.test(value)
      const hasSymbols = passwordRegexContainsSymbol.test(value)
      const hasAlphabet = passwordRegexContainsAlphabet.test(value)
      return (
        (hasDigit && hasSymbols) ||
        (hasSymbols && hasAlphabet) ||
        (hasAlphabet && hasDigit)
      )
    },
  },
  {
    errorMessage: msgContainsJapanese,
    validate(value: string): boolean {
      return value.length === 0 || passwordRegexAllValid.test(value)
    },
  },
]

export const validatePassword = (password: string): string[] =>
  passwordValidators
    .filter(validator => !validator.validate(password))
    .map(({ errorMessage }) => errorMessage)
